import { t } from "i18next";
import { Badge, Button, Spinner } from "reactstrap";
import { MediaStatusEnum } from "../../interfaces/media";
import { FC } from "react";
import { useUpdateMediaStatusMutation } from "../../store/api/mediaApi";

type TProps = {
  type: "Lecture" | "Skill" | "LiveLecture";
  lectureOrSkillId: string;
  status: MediaStatusEnum;
  mediaId: string;
};
export const MediaStatus: FC<TProps> = ({
  type,
  lectureOrSkillId,
  status,
  mediaId,
}) => {
  const [updateMediaStatus] = useUpdateMediaStatusMutation();

  const onRetry = async () => {
    try {
      await updateMediaStatus({
        id: mediaId,
        status: MediaStatusEnum.NEW,
      }).unwrap();
    } catch (err) {}
  };

  const getBadgeColor = (_status: MediaStatusEnum) => {
    // @ts-ignore
    if (_status == MediaStatusEnum.NEW) {
      return "secondary";
    }
    // @ts-ignore
    if (_status == MediaStatusEnum.PROCESSING) {
      return "warning";
    }
    // @ts-ignore
    if (_status == MediaStatusEnum.COMPLETED) {
      return "primary";
    }
    // @ts-ignore
    if (_status == MediaStatusEnum.FAILED) {
      return "danger";
    }
  };

  return (
    <>
      <Badge color={getBadgeColor(status || MediaStatusEnum.NEW)}>
        <span>
          {t("conversionStatus")}: {t(status || "")}
        </span>
      </Badge>
      {status === MediaStatusEnum.PROCESSING && (
        <Spinner size={"sm"} color="warning" className="mx-1" />
      )}
      {status === MediaStatusEnum.FAILED && (
        <Button className="btn btn-sm mx-1" onClick={onRetry}>
          {t("retry")}
        </Button>
      )}
    </>
  );
};
